export const ShopProduct = {
    'shop_product': 'Shop Product',
    'name': 'Name',
    'image': 'Image',
    'description': 'Description',
    'mrp': 'MRP',
    'price': 'Price',
    'status': 'Status',
    'shop_category': 'Shop Category',
    'shop_sub_category': 'Shop Sub Category',
    'table_no': 'No.',
    'table_name': 'PRODUCT NAME',
    'table_image': 'IMAGE',
    'table_category': 'CATEGORY',
    'table_sub_category': 'SUB CATEGORY',
    'table_mrp': 'MRP',
    'table_price': 'PRICE',
    'table_status': 'STATUS',
    'error_name': 'Product Name is required',
    'error_image': 'Product Image is required',
    'error_description': 'Description is required',
    'error_mrp': 'MRP is required',
    'error_price': 'Price is required',
    'error_status': 'Status is required',
    'error_category': 'Shop Category is required',
    'error_sub_category': 'Shop Sub Category is required',
}
